module.exports = __webpack_public_path__ + "static/media/about-3.ff64924f.jpg";